<template>
  <form @submit.prevent="submit" :class="errorClass">
    <h2 class="registration-title">Create account</h2>
    <div class="registration-header">Please create an account so you can continue</div>

    <div class="input-side-by-side">
      <rp-textinput
        v-model="resource.first_name"
        placeholder="First name"
        :error="first_nameError"
        isRequired
        @input="touch('first_name')"/>

      <rp-textinput
        v-model="resource.last_name"
        placeholder="Last name"
        :error="last_nameError"
        isRequired
        @input="touch('last_name')"/>
    </div>

    <rp-textinput
      v-model="resource.email"
      placeholder="Email"
      :error="emailError"
      isRequired
      @input="touch('email')"/>

    <div class="input-side-by-side">
      <rp-password
        v-model="resource.password"
        placeholder="Password"
        :error="passwordError"
        isRequired
        @input="touch('password')"/>

      <rp-password
        v-model="resource.password_confirmation"
        placeholder="Confirm password"
        :error="password_confirmationError"
        isRequired
        @input="touch('password_confirmation')"/>
    </div>

    <rp-select
      class="role"
      v-model="resource.role"
      placeholder="Select role"
      isRequired
      @input="touch('role')"
      :error="roleError">
      <option v-for="(option,index) in roles" :value="option.value" :key="index">
        {{option.key}}
      </option>
    </rp-select>

    <rp-checkbox
      v-model="resource.endUserLicense"
      link="https://rayner.com/global/terms/"
      label="You must agree to the following important terms of use before creating a RayPRO account"
      @input="touch('endUserLicense')"
      :error="endUserLicenseError"/>

    <rp-checkbox
      v-model="resource.endUserPrivacy"
      link="https://rayner.com/global/raypro/patientprivacy/"
      label="GDPR and Rayner accessing data"
      @input="touch('endUserPrivacy')"
      :error="endUserPrivacyError"/>

      <vue-recaptcha :sitekey="recaptcha_site_key" :loadRecaptchaScript="true" @verify="verified"></vue-recaptcha>

    <rp-button :disabled="isInvalid" type="primary">Sign up</rp-button>
  </form>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';

  import {validationMixin} from 'vuelidate'
  import {email, required, sameAs} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import Password from '../../../components/ui/inputs/PasswordInput'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import DatePicker from '../../../components/ui/inputs/DatePicker'
  import Select from '../../../components/ui/inputs/StyledSelect'
  import Checkbox from '../../../components/ui/inputs/Checkbox'

  const RECAPTCHA_KEY = runtimeconfig.RECAPTCHA_KEY || process.env.RECAPTCHA_KEY

  export default {
    name: 'RegistrationForm',
    mixins: [validationMixin, form],

    data() {
      return {
        recaptcha_site_key: RECAPTCHA_KEY
      };
    },

    props: {
      roles: Array,
      locales: Array,
    },

    components: {
      VueRecaptcha,
      'rp-button': Button,
      'rp-password': Password,
      'rp-textinput': TextInput,
      'rp-datepicker': DatePicker,
      'rp-select': Select,
      'rp-checkbox': Checkbox
    },

    computed: {
      ...errorMessages([
        'email',
        'password',
        'password_confirmation',
        'first_name',
        'last_name',
        'role',
        'endUserPrivacy',
        'endUserLicense',
      ]),
    },

    methods: {
      verified(response) {
        this.$set(this.resource, 'recaptchaToken', response)
      },
    },

    watch: {
      locales: function (locales) {
        if (locales && locales[0]) {
          this.resource.locale_id = locales[0].value
        }
      }
    },

    validations: {
      resource: {
        email: {required, email},
        password: {required},
        password_confirmation: {sameAs: sameAs('password')},
        first_name: {required},
        last_name: {required},
        role: {required},
        endUserPrivacy: {terms: sameAs(() => {return true})},
        endUserLicense: {terms: sameAs(() => {return true})},
        recaptchaToken: {required},
      }
    },
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'

  .registration-header
    font-size: 1.6rem

  .input-side-by-side
    display: flex
    gap: 10px

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/Registration_v2.vue